// extracted by mini-css-extract-plugin
export default {"birthdate":"styles_birthdate__mpeIo","container":"styles_container__qHapm","selectTrigger":"styles_selectTrigger__UtzKY","selectIcon":"styles_selectIcon__zTmEh"};